import {
  Media,
  MediasAndArticleCountResponse,
} from "@coworker/app/src/components/RoomSettings/types/media";
import useTranslation from "../../../../../packages/locales/translations/util/useTranslation";
import styles from "./media-placement-section.module.css";
import { MediaNameAndType } from "./MediaNameAndType/MediaNameAndType";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { Groups } from "./Groups/Groups";
import { MediaPlacementsModal } from "./MediaPlacementsModal/MediaPlacementsModal";
import { useState } from "react";

interface MediaPlacementSectionProps {
  media: Media;
  mediasAndArticleCount: MediasAndArticleCountResponse[];
  itemCardContent: React.ReactElement;
}

export const MediaPlacementSection = ({
  mediasAndArticleCount,
  media,
  itemCardContent,
}: MediaPlacementSectionProps) => {
  const { t } = useTranslation();

  const currentMediaAndArticleCount = mediasAndArticleCount.filter(
    (mediaAndArticleCount) => mediaAndArticleCount.mediaId === media.id
  );

  const currentMedia = currentMediaAndArticleCount?.[0];

  const currentMediaArticlesInGroups = currentMediaAndArticleCount.filter(
    (mediaAndArticleCount) => mediaAndArticleCount.groupId !== null
  );

  const [showMediasPlacementModal, setShowMediasPlacementModal] =
    useState(false);

  const handleShowMediasPlacementModal = () => {
    setShowMediasPlacementModal(true);
  };

  return (
    <>
      <div className={styles["media-placement-section"]}>
        <div className={styles["media-placement-inner-container"]}>
          <MediaNameAndType
            mediaName={currentMedia?.name ?? ""}
            mediaType={currentMedia?.mediaType ?? ""}
          />
          <Groups articleInGroups={currentMediaArticlesInGroups} />
        </div>
        <div className={styles["show-modal-button-container"]}>
          <FixaButton
            text={t("findArticleInOtherMediaString")}
            htmlType="button"
            fluid
            size="medium"
            onClick={handleShowMediasPlacementModal}
          />
          <MediaPlacementsModal
            itemCardContent={itemCardContent}
            showModal={showMediasPlacementModal}
            mediasAndArticleCount={mediasAndArticleCount}
            onClose={() => setShowMediasPlacementModal(false)}
          />
        </div>
      </div>
    </>
  );
};
